/** @jsx jsx */
import React from "react";
import PropTypes from "prop-types";
import { jsx, css } from "@emotion/core";
import { Link, withRouter } from "react-router-dom";
import { colors } from "../../theme";

export const BackButton = ({ onClick }) => (
    <a
        data-testid="back-button"
        css={css`
            font-size: 14px;
            color: ${colors.neutral6};
            text-decoration: none;
            > * {
                cursor: pointer;
            }
            > span {
                @media (max-width: 520px) {
                    display: none;
                }
            }
        `}
        onClick={onClick}
    >
        &lt; <span>Back</span>
    </a>
);

BackButton.propTypes = {
    onClick: PropTypes.func,
};

const BackButtonWithRouter = withRouter(({ history }) => (
    <BackButton onClick={() => history.goBack()} />
));

export default BackButtonWithRouter;
